import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Signup from "./Signup";
import axios from "axios";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Col,
} from "reactstrap";
import Header from "../Header/Header";
import { TableHeader, Pagination, Search } from "../../DataTable";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import Baja from "../../views/Baja";

import Swal from "sweetalert2";
import CryptoJS from 'crypto-js'

function ListadoUsuarios() {
  const { user } = useContext(AuthContext);
  const URL_USERS = import.meta.env.VITE_URL_USERS;
  const URL_LISTA_USERS = import.meta.env.VITE_URL_LISTA_USERS;
  const URL_GRIDCONFIG = import.meta.env.VITE_URL_GRID_CONFIG;
  const encryptionKey = import.meta.env.VITE_ENCRYPTION_KEY
  const [config, setConfig] = useState("");
  // eslint-disable-next-line
  const [idConfig, setIdConfig] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  // eslint-disable-next-line
  const [activo, setActivo] = useState("");
  const ITEMS_PER_PAGE = 50;

  const [idEdit, setIdEdit] = useState();
  const [nombre, setNombre] = useState();
  const [email, setEmail] = useState();
  const [apiKey, setApiKey] = useState();
  const [secretKey, setSecretKey] = useState();

  const [idPermisos, setIdPermisos] = useState();

  const [menu_usuarios, setMenuUsuarios] = useState();
  const [usuarios_create, setUsuariosCreate] = useState();
  const [usuarios_permisos, setUsuariosPermisos] = useState();
  const [dashboard, setDashboard] = useState();

  const [menu_logs, setMenuLogs] = useState();
  const [menu_admin, setMenuAdmin] = useState();

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [modalPermisos, setModalPermisos] = useState(false);
  const togglePermisos = () => setModalPermisos(!modalPermisos);

  // GridConfig states
  const [modalGridConfig, setModalGridConfig] = useState(false);
  const [modalAddPair, setModalAddPair] = useState(false);
  const [modalEditConfig, setModalEditConfig] = useState(false);
  const [modalTelegram, setModalTelegram] = useState(false);

  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [userGridConfigs, setUserGridConfigs] = useState([]);
  const [selectedGridConfig, setSelectedGridConfig] = useState(null);

  // Telegram states
  const [telegramEnabled, setTelegramEnabled] = useState(false);
  const [telegramChatId, setTelegramChatId] = useState("");
  const [telegramNotifications, setTelegramNotifications] = useState({
    orderFills: true,
    botStatus: true,
    exposureWarnings: true,
    rebalance: true,
    errors: true,
    profitMilestones: true
  });

  // New pair states
  const [newSymbol, setNewSymbol] = useState("");
  const [newBaseAsset, setNewBaseAsset] = useState("");
  const [newQuoteAsset, setNewQuoteAsset] = useState("USDT");

  const toggleGridConfig = () => setModalGridConfig(!modalGridConfig);
  const toggleAddPair = () => setModalAddPair(!modalAddPair);
  const toggleEditConfig = () => setModalEditConfig(!modalEditConfig);
  const toggleTelegram = () => setModalTelegram(!modalTelegram);

  useEffect(() => {
    // 1. Cargar Usuarios
    axios
      .get(URL_LISTA_USERS, {
        headers: {
          // CORRECCIÓN: Quitamos los dos puntos ':' después de Bearer
          Authorization: `Bearer ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allUsuarios = response.data;
        let arrayTabla = allUsuarios
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              is_active: a.is_active,
              menu_usuarios: a.menu_usuarios,
              usuarios_create: a.usuarios_create,
              usuarios_permisos: a.usuarios_permisos,
              menu_logs: a.menu_logs,
              menu_admin: a.menu_admin,
              dashboard: a.dashboard,
              nombre: a.nombre,
              email: a.email,
              apiKey: a.apiKey,
              secretKey: a.secretKey,
              tipo: a.tipo,
              telegramChatId: a.telegramChatId,
              telegramNotifications: a.telegramNotifications,
              telegramEnabled: a.telegramEnabled,
            };
          })
          .filter((el) => el != null);

        setComments(arrayTabla);
      })
      .catch((err) => {
        console.error("Error cargando usuarios:", err);
      });

  }, [URL_LISTA_USERS]);


  const headers = [
    { name: "Activo", field: "is_active", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Email", field: "email", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.is_active.toLowerCase().includes(search.toLowerCase()) ||
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.email.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.is_active.includes(activo)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Pagination
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting, activo]);

  const encryptAPISecret = (apiSecret) => {
    if (!apiSecret) return "";
    return CryptoJS.AES.encrypt(apiSecret, encryptionKey).toString();
  };

  const decryptAPISecret = (encryptedSecret) => {
    if (!encryptedSecret) return "";
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedSecret, encryptionKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return "";
    }
  };

  function Edit(idEdit, nombre, email, apiKey, secretKey) {
    const decryptApiKey = decryptAPISecret(apiKey);
    const decryptSecretKey = decryptAPISecret(secretKey);

    setIdEdit(idEdit);
    setNombre(nombre);
    setEmail(email);
    setApiKey(decryptApiKey);
    setSecretKey(decryptSecretKey);
    toggle();
  }

  function editUsuario(event) {
    event.preventDefault();

    const encryptedApiKey = encryptAPISecret(apiKey);
    const encryptedSecretKey = encryptAPISecret(secretKey);

    axios
      .patch(
        `${URL_USERS}/${idEdit}`,
        {
          nombre,
          email,
          apiKey: encryptedApiKey,
          secretKey: encryptedSecretKey,
          // CORRECCIÓN: Eliminada la variable 'agresivo' que no existía
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: error.response ? error.response.data : "Error de red",
        });
        console.log(error);
      });
  }

  function Permisos(
    id,
    nombre,
    menu_usuarios,
    usuarios_create,
    usuarios_permisos,
    dashboard,
    menu_logs,
    menu_admin,
  ) {
    setIdPermisos(id);
    setNombre(nombre);
    setMenuUsuarios(menu_usuarios);
    setUsuariosCreate(usuarios_create);
    setUsuariosPermisos(usuarios_permisos);
    setDashboard(dashboard);
    setMenuLogs(menu_logs);
    setMenuAdmin(menu_admin);
    togglePermisos();
  }

  function permisosUsuario(event) {
    event.preventDefault();
    axios
      .patch(
        `${URL_USERS}/${idPermisos}`,
        {
          menu_usuarios,
          usuarios_create,
          usuarios_permisos,
          dashboard,
          menu_logs,
          menu_admin,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        togglePermisos();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: error.response ? error.response.data : "Error de red",
        });
        console.log(error);
      });
  }

  // Fetch user's GridConfigs
  async function fetchUserGridConfigs(userId, userName) {
    setSelectedUserId(userId);
    setSelectedUserName(userName);
    
    try {
      const response = await axios.get(
        `${URL_GRIDCONFIG}/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("app_token")}`,
          },
        }
      );
      
      setUserGridConfigs(response.data.configs || []);
      toggleGridConfig();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudieron cargar las configuraciones",
      });
      console.error(error);
    }
  }

  // Edit GridConfig
  function editGridConfig(config) {
    setSelectedGridConfig(config);
    toggleEditConfig();
  }

  // Update GridConfig
  async function updateGridConfig(event) {
    event.preventDefault();
    
    try {
      await axios.put(
        `${URL_GRIDCONFIG}/${selectedUserId}/${selectedGridConfig.symbol}`,
        selectedGridConfig,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("app_token")}`,
          },
        }
      );
      
      toggleEditConfig();
      Swal.fire("Éxito!", "Configuración actualizada", "success");
      fetchUserGridConfigs(selectedUserId, selectedUserName); // Refresh
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo actualizar la configuración",
      });
      console.error(error);
    }
  }

  // Add new trading pair
  async function addNewPair(event) {
    event.preventDefault();
    
    try {
      await axios.post(
        URL_GRIDCONFIG,
        {
          user: selectedUserId,
          symbol: newSymbol,
          baseAsset: newBaseAsset,
          quoteAsset: newQuoteAsset,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("app_token")}`,
          },
        }
      );
      
      toggleAddPair();
      Swal.fire("Éxito!", "Par agregado exitosamente", "success");
      fetchUserGridConfigs(selectedUserId, selectedUserName); // Refresh
      
      // Clear form
      setNewSymbol("");
      setNewBaseAsset("");
      setNewQuoteAsset("USDT");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.error || "No se pudo agregar el par",
      });
      console.error(error);
    }
  }

  // Open Telegram settings modal
  function openTelegramSettings(userId, userName, userData) {
    setSelectedUserId(userId);
    setSelectedUserName(userName);
    setTelegramEnabled(userData.telegramEnabled || false);
    setTelegramChatId(userData.telegramChatId || "");
    setTelegramNotifications(userData.telegramNotifications || {
      orderFills: true,
      botStatus: true,
      exposureWarnings: true,
      rebalance: true,
      errors: true,
      profitMilestones: true
    });
    toggleTelegram();
  }

  // Update Telegram settings
  async function updateTelegramSettings(event) {
    event.preventDefault();
    
    try {
      await axios.patch(
        `${URL_USERS}/${selectedUserId}`,
        {
          telegramEnabled,
          telegramChatId,
          telegramNotifications,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("app_token")}`,
          },
        }
      );
      
      toggleTelegram();
      Swal.fire("Éxito!", "Configuración de Telegram actualizada", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo actualizar la configuración",
      });
      console.error(error);
    }
  }

  return (
    <>
      <Header />
      <br />
      {user.menu_usuarios ? (
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-8 mb-4">
              <div className="card">
                <div className="card-body">
                  <h3 className="text-center">Usuarios</h3>
                  <div className="row mb-3">
                    <div className="col-12 col-md-6 mb-2">
                      <Pagination
                        total={totalItems}
                        itemsPerPage={ITEMS_PER_PAGE}
                        currentPage={currentPage}
                        onPageChange={(page) => setCurrentPage(page)}
                      />
                    </div>
                    <div className="col-12 col-md-6 d-flex justify-content-end">
                      <Search
                        onSearch={(value) => {
                          setSearch(value);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                  <Table
                    size="sm"
                    striped
                    borderless
                    className="table-responsive-xl"
                  >
                    <TableHeader
                      headers={headers}
                      onSorting={(field, order) => setSorting({ field, order })}
                    />
                    <tbody>
                      {commentsData.map((p) => (
                        <tr key={p._id}>
                          <td>{p.is_active}</td>
                          <td>{p.nombre}</td>
                          <td>{p.email}</td>
                          <td>
                            <div className="d-flex flex-wrap gap-2">
                              <Button
                                color="info"
                                size="sm"
                                onClick={() => {
                                  Edit(p._id, p.nombre, p.email, p.apiKey, p.secretKey);
                                }}
                                disabled={!user.usuarios_create}
                                title="Editar Usuario"
                              >
                                <i className="far fa-edit"></i>
                              </Button>
                              
                              <Button
                                color="primary"
                                size="sm"
                                onClick={() => fetchUserGridConfigs(p._id, p.nombre)}
                                disabled={!user.usuarios_create}
                                title="Gestionar Pares de Trading"
                              >
                                <i className="fas fa-chart-line"></i>
                              </Button>
                              
                              <Button
                                color="warning"
                                size="sm"
                                onClick={() => openTelegramSettings(p._id, p.nombre, p)}
                                disabled={!user.usuarios_create}
                                title="Configurar Telegram"
                              >
                                <i className="fab fa-telegram"></i>
                              </Button>
                              
                              {p.tipo === "Admin" ? (
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() =>
                                    Permisos(
                                      p._id,
                                      p.nombre,
                                      p.menu_usuarios,
                                      p.usuarios_create,
                                      p.usuarios_permisos,
                                      p.dashboard,
                                      p.menu_logs,
                                      p.menu_admin
                                    )
                                  }
                                  disabled={!user.usuarios_permisos || p.is_active !== "Si"}
                                  title="Permisos"
                                >
                                  <i className="fas fa-key"></i>
                                </Button>
                              ) : null}
                              
                              <Baja
                                idStatus={p._id}
                                is_active={p.is_active}
                                URL_BAJA={import.meta.env.VITE_URL_USERS}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>

            {/* Formulario de Signup */}
            <div className="col-12 col-lg-4">
              <div className="card">
                <div className="card-body">
                  <Signup />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : undefined}

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Editar Usuario {nombre}</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Nombre</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={nombre}
            required
            onChange={(e) => {
              setNombre(e.target.value);
            }}
          />
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={email}
            required
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        
          <Label>Api Key</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={apiKey}
            required
            onChange={(e) => {
              setApiKey(e.target.value);
            }}
          />
          <Label>Secret Key</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={secretKey}
            required
            onChange={(e) => {
              setSecretKey(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editUsuario}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {/* //Permisos */}
      <Modal size="xl" isOpen={modalPermisos} toggle={togglePermisos}>
        <ModalHeader toggle={togglePermisos}>
          <h4>Permisos de {nombre}</h4>
        </ModalHeader>
        <ModalBody>
          <div className="container">
            <Row>
              <Col md={3}>
                <h5>ADMIN</h5>
                <Input
                  type="checkbox"
                  onChange={(event) =>
                    setMenuAdmin(event.currentTarget.checked)
                  }
                  checked={menu_admin}
                />
                <h5 className="subMenuTitulo">Menu Admin</h5>
              </Col>

              <Col md={3}>
                <h5>DASHBOARD</h5>
                <Input
                  type="checkbox"
                  onChange={(event) =>
                    setDashboard(event.currentTarget.checked)
                  }
                  checked={dashboard}
                />
                <h5 className="subMenuTitulo">Dashboard</h5>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={3}>
                <h5>USUARIOS</h5>
                <Input
                  type="checkbox"
                  onChange={(event) =>
                    setMenuUsuarios(event.currentTarget.checked)
                  }
                  checked={menu_usuarios}
                />
                <h5 className="subMenuTitulo">Menu Usuarios</h5>
              </Col>

              <Col md={3}>
                <h5>LOGS</h5>
                <Input
                  type="checkbox"
                  onChange={(event) => setMenuLogs(event.currentTarget.checked)}
                  checked={menu_logs}
                />
                <h5 className="subMenuTitulo">Menu Logs</h5>
              </Col>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="container">
            <Button color="success" onClick={permisosUsuario}>
              Guardar
            </Button>
          </div>
        </ModalFooter>
      </Modal>

      {/* Modal: GridConfig Management */}
      <Modal size="xl" isOpen={modalGridConfig} toggle={toggleGridConfig}>
        <ModalHeader toggle={toggleGridConfig}>
          <h4>Configuraciones de Trading - {selectedUserName}</h4>
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <Button 
              color="success" 
              onClick={toggleAddPair}
            >
              <i className="fas fa-plus"></i> Agregar Nuevo Par
            </Button>
          </div>
          
          <Table striped responsive>
            <thead>
              <tr>
                <th>Par</th>
                <th>Base</th>
                <th>Quote</th>
                <th>Activo</th>
                <th>Niveles</th>
                <th>Step %</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {userGridConfigs.map((config) => (
                <tr key={config._id}>
                  <td>{config.symbol}</td>
                  <td>{config.baseAsset}</td>
                  <td>{config.quoteAsset}</td>
                  <td>{config.isActive ? "Si" : "No"}</td>
                  <td>{config.totalLevels}</td>
                  <td>{(config.stepPercent * 100).toFixed(2)}%</td>
                  <td>
                    <Button
                      color="info"
                      size="sm"
                      onClick={() => editGridConfig(config)}
                    >
                      <i className="far fa-edit"></i> Editar
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          
          {userGridConfigs.length === 0 && (
            <div className="text-center text-muted p-4">
              No hay configuraciones disponibles
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleGridConfig}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal: Add New Trading Pair */}
      <Modal isOpen={modalAddPair} toggle={toggleAddPair}>
        <ModalHeader toggle={toggleAddPair}>
          <h4>Agregar Nuevo Par de Trading</h4>
        </ModalHeader>
        <ModalBody>
          <Label>Symbol (ej: ETHUSDT)</Label>
          <Input
            type="text"
            value={newSymbol}
            onChange={(e) => setNewSymbol(e.target.value.toUpperCase())}
            placeholder="ETHUSDT"
            required
          />
          
          <Label className="mt-2">Base Asset (ej: ETH)</Label>
          <Input
            type="text"
            value={newBaseAsset}
            onChange={(e) => setNewBaseAsset(e.target.value.toUpperCase())}
            placeholder="ETH"
            required
          />
          
          <Label className="mt-2">Quote Asset</Label>
          <Input
            type="text"
            value={newQuoteAsset}
            onChange={(e) => setNewQuoteAsset(e.target.value.toUpperCase())}
            placeholder="USDT"
            required
          />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={addNewPair}>
            Agregar
          </Button>
          <Button color="secondary" onClick={toggleAddPair}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal: Edit GridConfig */}
      {selectedGridConfig && (
        <Modal size="xl" isOpen={modalEditConfig} toggle={toggleEditConfig}>
          <ModalHeader toggle={toggleEditConfig}>
            <h4>Editar Configuración: {selectedGridConfig.symbol}</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={6}>
                <h5>Estado</h5>
                  <Input
                    type="checkbox"
                    checked={selectedGridConfig.isActive}
                    onChange={(e) => setSelectedGridConfig({
                      ...selectedGridConfig,
                      isActive: e.target.checked
                    })}
                  />
                <Label className="subMenuTitulo">Bot Activo
                </Label>
                <br />
                  <Input
                    type="checkbox"
                    checked={selectedGridConfig.botEnabled}
                    onChange={(e) => setSelectedGridConfig({
                      ...selectedGridConfig,
                      botEnabled: e.target.checked
                    })}
                  />
                <Label className="subMenuTitulo">Bot Habilitado</Label>
              </Col>
              
              <Col md={6}>
                <h5>Estructura de Grilla</h5>
                <Label>Niveles Totales</Label>
                <Input
                  type="number"
                  value={selectedGridConfig.totalLevels}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    totalLevels: parseInt(e.target.value)
                  })}
                />
                
                <Label>Niveles de Compra</Label>
                <Input
                  type="number"
                  value={selectedGridConfig.buyLevels}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    buyLevels: parseInt(e.target.value)
                  })}
                />
                
                <Label>Niveles de Venta</Label>
                <Input
                  type="number"
                  value={selectedGridConfig.sellLevels}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    sellLevels: parseInt(e.target.value)
                  })}
                />
              </Col>
            </Row>
            
            <Row className="mt-3">
              <Col md={6}>
                <h5>Porcentajes</h5>
                <Label>Step Percent (%)</Label>
                <Input
                  type="number"
                  step="0.0001"
                  value={(selectedGridConfig.stepPercent * 100).toFixed(4)}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    stepPercent: parseFloat(e.target.value) / 100
                  })}
                />
                
                <Label>Range Percent (%)</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={(selectedGridConfig.rangePercent * 100).toFixed(2)}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    rangePercent: parseFloat(e.target.value) / 100
                  })}
                />
                
                <Label>Min Profit Percent (%)</Label>
                <Input
                  type="number"
                  step="0.001"
                  value={(selectedGridConfig.minProfitPercent * 100).toFixed(3)}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    minProfitPercent: parseFloat(e.target.value) / 100
                  })}
                />
              </Col>
              
              <Col md={6}>
                <h5>Ratios de Capital</h5>
                <Label>Capital Usage Percent (%)</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={(selectedGridConfig.capitalUsagePercent * 100).toFixed(2)}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    capitalUsagePercent: parseFloat(e.target.value) / 100
                  })}
                />
                
                <Label>Target Base Ratio</Label>
                <Input
                  type="number"
                  step="0.01"
                  min="0"
                  max="1"
                  value={selectedGridConfig.targetBaseRatio}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    targetBaseRatio: parseFloat(e.target.value)
                  })}
                />
                
                <Label>Target Quote Ratio</Label>
                <Input
                  type="number"
                  step="0.01"
                  min="0"
                  max="1"
                  value={selectedGridConfig.targetQuoteRatio}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    targetQuoteRatio: parseFloat(e.target.value)
                  })}
                />
              </Col>
            </Row>
            
            <Row className="mt-3">
              <Col md={12}>
                <h5>Límites Hold Mode</h5>
              </Col>
              <Col md={4}>
                <Label>Max Base Ratio</Label>
                <Input
                  type="number"
                  step="0.01"
                  min="0"
                  max="1"
                  value={selectedGridConfig.maxBaseRatio}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    maxBaseRatio: parseFloat(e.target.value)
                  })}
                />
              </Col>
              <Col md={4}>
                <Label>Min Base Ratio</Label>
                <Input
                  type="number"
                  step="0.01"
                  min="0"
                  max="1"
                  value={selectedGridConfig.minBaseRatio}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    minBaseRatio: parseFloat(e.target.value)
                  })}
                />
              </Col>
              <Col md={4}>
                <Label>Min Quote Ratio</Label>
                <Input
                  type="number"
                  step="0.01"
                  min="0"
                  max="1"
                  value={selectedGridConfig.minQuoteRatio}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    minQuoteRatio: parseFloat(e.target.value)
                  })}
                />
              </Col>
            </Row>
            
            <Row className="mt-3">
              <Col md={12}>
                <h5>Protección contra Caídas</h5>
              </Col>
              <Col md={4}>
                  <Input
                    type="checkbox"
                    checked={selectedGridConfig.enableRapidCrashProtection}
                    onChange={(e) => setSelectedGridConfig({
                      ...selectedGridConfig,
                      enableRapidCrashProtection: e.target.checked
                    })}
                  />
                  <Label className="subMenuTitulo">Habilitar Protección
                </Label>
              </Col>
              <Col md={4}>
                <Label>Rapid Crash Percent (%)</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={(selectedGridConfig.rapidCrashPercent * 100).toFixed(2)}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    rapidCrashPercent: parseFloat(e.target.value) / 100
                  })}
                />
              </Col>
              <Col md={4}>
                <Label>Tiempo (segundos)</Label>
                <Input
                  type="number"
                  value={selectedGridConfig.rapidCrashTimeSeconds}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    rapidCrashTimeSeconds: parseInt(e.target.value)
                  })}
                />
              </Col>
            </Row>
            
            <Row className="mt-3">
              <Col md={12}>
                <h5>Configuración Avanzada</h5>
              </Col>
              <Col md={3}>
                <Label>Rebase Delay (min)</Label>
                <Input
                  type="number"
                  value={selectedGridConfig.rebaseDelayMinutes}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    rebaseDelayMinutes: parseInt(e.target.value)
                  })}
                />
              </Col>
              <Col md={3}>
                <Label>Fall Step Percent (%)</Label>
                <Input
                  type="number"
                  step="0.001"
                  value={(selectedGridConfig.fallStepPercent * 100).toFixed(3)}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    fallStepPercent: parseFloat(e.target.value) / 100
                  })}
                />
              </Col>
              <Col md={3}>
                  <Input
                    type="checkbox"
                    checked={selectedGridConfig.usePostOnly}
                    onChange={(e) => setSelectedGridConfig({
                      ...selectedGridConfig,
                      usePostOnly: e.target.checked
                    })}
                  />
                  <Label className="subMenuTitulo">Post Only
                </Label>
              </Col>
              <Col md={3}>
                  <Input
                    type="checkbox"
                    checked={selectedGridConfig.payFeesInBNB}
                    onChange={(e) => setSelectedGridConfig({
                      ...selectedGridConfig,
                      payFeesInBNB: e.target.checked
                    })}
                  />
                  <Label className="subMenuTitulo">Pagar Fees en BNB
                </Label>
              </Col>
            </Row>
            
            <Row className="mt-3">
              <Col md={12}>
                <h5>High Frequency Grid</h5>
              </Col>
              <Col md={4}>
                  <Input
                    type="checkbox"
                    checked={selectedGridConfig.hfGridEnabled}
                    onChange={(e) => setSelectedGridConfig({
                      ...selectedGridConfig,
                      hfGridEnabled: e.target.checked
                    })}
                  />
                  <Label className="subMenuTitulo">HF Grid Habilitado
                </Label>
              </Col>
              <Col md={4}>
                <Label>HF Rebase Threshold (%)</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={(selectedGridConfig.hfRebaseThresholdPercent * 100).toFixed(2)}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    hfRebaseThresholdPercent: parseFloat(e.target.value) / 100
                  })}
                />
              </Col>
              <Col md={4}>
                <Label>HF Check Interval (ms)</Label>
                <Input
                  type="number"
                  value={selectedGridConfig.hfCheckIntervalMs}
                  onChange={(e) => setSelectedGridConfig({
                    ...selectedGridConfig,
                    hfCheckIntervalMs: parseInt(e.target.value)
                  })}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button 
              color="success" 
              onClick={updateGridConfig}
            >
              Guardar Cambios
            </Button>
            <Button color="secondary" onClick={toggleEditConfig}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      )}

      {/* Modal: Telegram Settings */}
      <Modal isOpen={modalTelegram} toggle={toggleTelegram}>
        <ModalHeader toggle={toggleTelegram}>
          <h4>Configuración de Telegram - {selectedUserName}</h4>
        </ModalHeader>
        <ModalBody>
            <Input
              type="checkbox"
              checked={telegramEnabled}
              onChange={(e) => setTelegramEnabled(e.target.checked)}
            />
          <Label className="subMenuTitulo">
           Habilitar Telegram
          </Label>
          <br />
          <Label className="mt-3">Chat ID</Label>
          <Input
            type="text"
            value={telegramChatId}
            onChange={(e) => setTelegramChatId(e.target.value)}
            placeholder="123456789"
            disabled={!telegramEnabled}
          />
          
          <hr className="mt-4" />
          <h5>Notificaciones</h5>
          
            <Input
              type="checkbox"
              checked={telegramNotifications.orderFills}
              onChange={(e) => setTelegramNotifications({
                ...telegramNotifications,
                orderFills: e.target.checked
              })}
              disabled={!telegramEnabled}
            />
          <Label className="subMenuTitulo">
            Order Fills
          </Label>
          <br />
          
            <Input
              type="checkbox"
              checked={telegramNotifications.botStatus}
              onChange={(e) => setTelegramNotifications({
                ...telegramNotifications,
                botStatus: e.target.checked
              })}
              disabled={!telegramEnabled}
            />
          <Label className="subMenuTitulo">
            Bot Status
          </Label>
          <br />
          
            <Input
              type="checkbox"
              checked={telegramNotifications.exposureWarnings}
              onChange={(e) => setTelegramNotifications({
                ...telegramNotifications,
                exposureWarnings: e.target.checked
              })}
              disabled={!telegramEnabled}
            />
          <Label className="subMenuTitulo">
            Exposure Warnings
          </Label>
          <br />
          
            <Input
              type="checkbox"
              checked={telegramNotifications.rebalance}
              onChange={(e) => setTelegramNotifications({
                ...telegramNotifications,
                rebalance: e.target.checked
              })}
              disabled={!telegramEnabled}
            />
          <Label className="subMenuTitulo">
            Rebalance
          </Label>
          <br />
          
            <Input
              type="checkbox"
              checked={telegramNotifications.errors}
              onChange={(e) => setTelegramNotifications({
                ...telegramNotifications,
                errors: e.target.checked
              })}
              disabled={!telegramEnabled}
            />
          <Label className="subMenuTitulo">
            Errors
          </Label>
          <br />
          
            <Input
              type="checkbox"
              checked={telegramNotifications.profitMilestones}
              onChange={(e) => setTelegramNotifications({
                ...telegramNotifications,
                profitMilestones: e.target.checked
              })}
              disabled={!telegramEnabled}
            />
          <Label className="subMenuTitulo">
            Profit Milestones
          </Label>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={updateTelegramSettings}>
            Guardar
          </Button>
          <Button color="secondary" onClick={toggleTelegram}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoUsuarios;